export default __webpack_public_path__ + "static/media/bg-tree.5230a0f7.png";